import BodyScan5 from './assets/audio/BodyScan5.m4a'
import BodyScan10 from './assets/audio/BodyScan10.mp3'
import BodyScan15 from './assets/audio/BodyScan15.m4a'
import BodyScan25 from './assets/audio/BodyScan25.mp3'

import BreathAwareness5 from './assets/audio/BreathAwareness5.m4a'
import BreathAwareness10 from './assets/audio/BreathAwareness10.mp3'
import BreathAwareness15 from './assets/audio/BreathAwareness15.m4a'
import BreathAwareness25 from './assets/audio/BreathAwareness25.mp3'

import ZeroIn10 from  './assets/audio/60_to_Zero_in_10_Seconds.mp3'
import MedicalSupport from  './assets/audio/Medical_Support.mp3'
import  PeaceAndCalm from  './assets/audio/Peace_and_Calm.mp3'


export const audioFile = (topic) => {
  switch (topic) {
    case '5 minutes Body scan ':
      return BodyScan5
    case '10 minutes Body scan ':
      return BodyScan10
    case '15 minutes Body scan ':
      return BodyScan15
    case '25 minutes Body scan ':
      return BodyScan25
    case '5 minutes Breath awareness ':
      return BreathAwareness5
      case '10 minutes Breath awareness ':
        return BreathAwareness10
      case '15 minutes Breath awareness ':
        return BreathAwareness15
      case '25 minutes Breath awareness ':
        return BreathAwareness25

      case '3 minutes 60 to Zero in 10 Seconds ':
        return ZeroIn10
      case '10 minutes Medical Support ':
        return MedicalSupport
      case '16 minutes Peace and Calm ':
        return PeaceAndCalm
      default:
      break
  }
}
